import { Fragment } from 'react';
import { KeenIcon } from '@/components';
import { Container } from '@/components/container';
import { toAbsoluteUrl } from '@/utils';
import { JobDetailsData } from '@/pages/buddy/types/JobDetailsData.ts';
import { useNavigate } from 'react-router-dom';

interface JobProfileHeroProps {
    job: JobDetailsData;
}

const JobProfileHero = ({ job }: JobProfileHeroProps) => {

    const navigate = useNavigate();

    return (
        <Fragment>
            <style>
                {`
                    .hero-bg {
                        background-image: url('${toAbsoluteUrl('/media/images/2600x1200/bg-1.png')}');
                    }
                `}
            </style>
            <div className="bg-center bg-cover bg-no-repeat hero-bg">
                <Container>
                    <div className="flex flex-col items-center gap-2 lg:gap-3 py-4 lg:py-5">
                        {/* Company Image and Name */}
                        {job.company_name && job.company_p_id && (
                            <div className="flex flex-col items-center text-gray-600 text-sm mt-2 cursor-pointer">
                                {/* Company Circle */}
                                <div
                                    className="flex items-center justify-center rounded-full border-2 border-primary bg-light h-[50px] w-[50px] hover:border-gray-800"
                                    onClick={() => navigate(`/company/${job.company_p_id}`)} // Navigate to company page
                                >
                                    {job.company_image_url ? (
                                        <img
                                            src={toAbsoluteUrl(job.company_image_url)}
                                            alt={job.company_name || 'Company image'}
                                            className="h-[25px] w-[25px] object-cover rounded-full"
                                        />
                                    ) : (
                                        <KeenIcon icon="home" className="default-color text-xl" />
                                    )}
                                </div>

                                {/* Company Name */}
                                <span
                                    onClick={() => navigate(`/company/${job.company_p_id}`)} // Navigate to company page
                                    className="text-xl font-semibold text-center text-primary hover:text-gray-800 cursor-pointer mt-1"
                                >
                                    {job.company_name}
                                </span>
                            </div>
                        )}

                        {/* Job Name */}
                        <div className="text-2xl font-semibold text-gray-800 text-center">{job.name}</div>

                        {/* Job Details */}
                        <div className="flex flex-col md:flex-row gap-2 items-center justify-center mt-2">
                            {job.location && (
                                <div className="flex items-center gap-1 text-gray-600 text-sm">
                                    <KeenIcon icon="geolocation" className="text-primary" />
                                    <span>{job.remote ? 'Remote' : job.location.toString()}</span>
                                </div>
                            )}
                            {job.salary_range && (
                                <div className="flex items-center gap-1 text-gray-600 text-sm">
                                    <KeenIcon icon="tag" className="text-primary" />
                                    <span>{job.salary_range}</span>
                                </div>
                            )}
                            {job.employment_type && (
                                <div className="flex items-center gap-1 text-gray-600 text-sm">
                                    <KeenIcon icon="watch" className="text-primary" />
                                    <span>{job.employment_type}</span>
                                </div>
                            )}
                        </div>
                    </div>
                </Container>
            </div>
        </Fragment>
    );
};

export { JobProfileHero };
